export default function TestDriveCenterDisclaimers() {
  return (
    <div className="bg-canvas-default px-2xl pb-4xl md:px-3xl lg:px-4xl">
      <div className="mx-auto flex max-w-[1272px] flex-col gap-y-xs text-text-weak t-body-xs">
        <p>*Delivery and shipping fee may apply.</p>
        <p>
          **Limitations and exclusions may apply. See our 7-day return policy at{' '}
          <a
            className="underline"
            href="https://www.carvana.com"
            target="_blank"
            rel="noopener"
            data-adobe-id="seven-day-return-policy"
            data-analytics-id="Test Drive Center - Disclaimers - 7-Day Return Policy"
            data-testid="test-drive-center-seven-day-policy"
          >
            carvana.com
          </a>
          .
        </p>
      </div>
    </div>
  );
}
